import { InjectionToken } from '@angular/core';
import { environment } from '../environments/environment';

export interface AppConfig {
  appName: string;
  appDisplayName: string;
  isProduction: boolean;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('AppConfig');

export const appConfig: AppConfig = {
  // DB-Namensraum: Standard 'bpweb' (DBs bpweb-*). Build-Profile koennen ihn ueber
  // environment.dbBaseName umbiegen — z.B. das mv-Profil auf 'bpweb-mv' (DBs bpweb-mv-*),
  // damit die MV-Instanz einen eigenen DB-Satz auf derselben (internen) Couch hat.
  appName: (environment as { dbBaseName?: string }).dbBaseName ?? 'bpweb',
  appDisplayName: 'BpWeb',
  isProduction: environment.production
};
